// A temporary value used to identify if the loop should be broken.
// See #1064, #1293
export default {};


// WEBPACK FOOTER //
// ../../../../~/async-es/internal/breakLoop.js